import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import { useState } from "react";

const useLaundry = () => {
  const {
    locale,
    selectedLaundryIndex,
    showPaymentModal,
    setShowPaymentModal,
    showServiceRequestModal,
    setShowServiceRequestModal,
    setServiceRequestCity,
    setServiceRequestBuilding,
    setServiceRequestFloor,
    setServiceTypesSelect,
    setNewItemType,
    setNewServiceTypes,
    setNewNumberOfItems,
    setNewPrice,
    setMainPrice,
    setTotalPrice,
    setPriceAfterDiscount,
    setNewDetailedOrder,
    setTakeAndGiveCheckbox,
  } = useBetween(useSelector((state) => state.useSharedState));
  const Laundry = useSelector((state) => state.AllLaunds[selectedLaundryIndex]);

  const [latitude] = useState("34.7175124");
  const [longitude] = useState("36.7181969");

  // const {modalDetailsOrderId, setModalDetailsOrderId} = useBetween(useSelector(state => state.useSharedLang));
  // Connect with api to get specified order details

  const handleCloseServiceRequestModal = () =>
    setShowServiceRequestModal(false);
  const handleShowServiceRequestModal = () => {
    // Clear Data
    setServiceRequestCity("choose-city");
    setServiceRequestBuilding();
    setServiceRequestFloor();
    setServiceTypesSelect([]);
    setNewItemType("");
    setNewServiceTypes([]);
    setNewNumberOfItems(1);
    setNewPrice(0);
    setMainPrice(0);
    setTotalPrice(0);
    setPriceAfterDiscount(0);
    setNewDetailedOrder([]);
    setTakeAndGiveCheckbox(false);
    /////////////////////////////////
    setShowServiceRequestModal(true);
  };

  const handleClosePaymentModal = () => setShowPaymentModal(false);
  const handleShowPaymentModal = () => {
    handleCloseServiceRequestModal();
    setShowPaymentModal(true);
  };
  return {
    locale,
    handleClosePaymentModal,
    handleShowPaymentModal,
    Laundry,
    latitude,
    longitude,
    showPaymentModal,
    showServiceRequestModal,
    handleShowServiceRequestModal,
    handleCloseServiceRequestModal,
  };
};

export default useLaundry;
